export default __webpack_public_path__ + "static/media/cat-7.cf13938f.svg";